import React, { useEffect } from 'react';
import { ErrorBoundary } from '@applyboard/ui-utils';
import { CefEvent, Platform, CefEventName } from "../../EventTracker";
import FallbackComponent from "./Common/FallbackComponent";
import { useIsMobile } from "./Common/useIsMobile";
import { useCefEventTracker } from "./Hooks/useCefEventTracker";
import Router from "../Wizards/Router";
var CefModal = function CefModal(_ref) {
  var initialPath = _ref.initialPath,
    onClose = _ref.onClose,
    _ref$onSave = _ref.onSave,
    onSave = _ref$onSave === void 0 ? null : _ref$onSave;
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent,
    Track = _useCefEventTracker.Track;
  var isMobile = useIsMobile();
  var platform = isMobile ? Platform.Mobile : Platform.Desktop;
  var fallbackElement = /*#__PURE__*/React.createElement(FallbackComponent, {
    onExit: onClose
  });
  useEffect(function () {
    trackEvent(CefEvent(CefEventName.Started, platform));
  }, [trackEvent, platform]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallbackElement: fallbackElement
  }, /*#__PURE__*/React.createElement(Track, null, /*#__PURE__*/React.createElement(Router, {
    initialPath: initialPath,
    onClose: onClose,
    onSave: onSave
  })));
};
export default CefModal;